import React from "react";
import { Row, Col, Form, Input, Select } from "antd";
import BannerCard from "../../../common/components/BannerCard";
import CleanButton from "../../../common/components/CleanButton";
import { allValidation, requiredValidation } from "../../../common/constants/Helpers";

const ResetPasswordForm = ({ ...props }) => {
  const { resetPasswordForm, resetPasswordLoading, recoveryQuestion, handleResetClick, handleOnCancelClick } = props;

  const validatePasswords = (rule, value, callback) => {
    const pass = resetPasswordForm.getFieldValue("PASSWORD");
    const confirmPass = resetPasswordForm.getFieldValue("CONFPASSWORD");
    if (!confirmPass) {
      callback("Confirm passwrod is required");
    } else if (pass !== confirmPass) {
      callback("The password you have entered does not match");
    }
    callback();
  };

  return (
    <Form layout="vertical" form={resetPasswordForm}>
      <Col xl={20} lg={24} md={24} sm={24} xs={24}>
        <BannerCard title="Reset Password">
          <br />
          <Row gutter={[12, 12]}>
            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
              <Form.Item label="Question" name="QUESTION" rules={requiredValidation}>
                <Select>
                  <Select.Option value={1}>{recoveryQuestion}</Select.Option>
                  <Select.Option value={2}>What is your Current Password?</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
              <Form.Item label="Answer to Question" name="ANSWER" rules={allValidation}>
                <Input />
              </Form.Item>
            </Col>
            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
              <Form.Item label="New Password" name="PASSWORD" rules={allValidation}>
                <Input.Password />
              </Form.Item>
            </Col>
            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
              <Form.Item label="Confirm New Password" name="CONFPASSWORD" rules={[...allValidation, { validator: validatePasswords }]}>
                <Input.Password />
              </Form.Item>
            </Col>
            <Form.Item name="AGENCY_ID" hidden>
              <Input />
            </Form.Item>
            <Form.Item name="REFERENCE_CODE" hidden>
              <Input />
            </Form.Item>
            <Col>
              <CleanButton icon="check" onClick={handleResetClick} loading={resetPasswordLoading}>
                Reset
              </CleanButton>
            </Col>
            <Col>
              <CleanButton icon="times" onClick={handleOnCancelClick}>
                Cancel
              </CleanButton>
            </Col>
          </Row>
        </BannerCard>
      </Col>
    </Form>
  );
};

export default ResetPasswordForm;
